class teamRequestModalRemoveQuestionController {
  constructor($translate) {
    'ngInject';
    this.$translate = $translate;
    this.errors = [];

    this
      .$translate('VACATIONS_ABSENCES.VALIDATION_ERRORS.REMOVE_REASON_MAX_LENGTH')
      .then((translation) => {
        this.errors.push(translation);
      });
  }

  $onInit(){
    if(this.isMobileApp){
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.REMOVE',

      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

  onDismiss(){
    angular.element('.modal').modal('hide');
  }
}

export default teamRequestModalRemoveQuestionController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalRemove/teamRequestModalRemoveQuestion/teamRequestModalRemoveQuestion.controller.js